import { render, staticRenderFns } from "./ServiceAndFeatureControllerCard.vue?vue&type=template&id=519dfdc4&scoped=true&"
import script from "./ServiceAndFeatureControllerCard.vue?vue&type=script&lang=js&"
export * from "./ServiceAndFeatureControllerCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAndFeatureControllerCard.vue?vue&type=style&index=0&id=519dfdc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519dfdc4",
  null
  
)

export default component.exports